import React, { Component } from 'react';
import {
  Correo,
  CorreoContainer,
  IconoAlerta,
  IconoCorreo,
  InputCorreo,
  TextCorreo,
  ButtonCorreo,
  FormCorreo,
  TextCorreoAlerta,
  ConsentimentDades,
  CheckboxConsentiment,
  TextCorreoLink
} from './ExportLayerElements';
import { toast } from 'react-toastify';
import { catalogObj as Data } from '../../../../../../components/Catalog/Data';
import { getTranslatedKey } from '../../../../../Utils/TranslateUtils';

export default class ExportCorreuModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFocused: false,
      email: this.props.userEmail || '',
      checked: false,
      buttonDisabled: true,
      bodyRequest: this.props.bodyRequest
    };
  }

  handleFocus = () => {
    this.setState({ isFocused: true });
  };

  handleEmailChange = (event) => {
    const newEmail = event.target.value;
    this.setState({ email: newEmail });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    this.setState(
      (prevState) => ({
        bodyRequest: {
          ...prevState.bodyRequest,
          emailAddress: this.state.email
        }
      }),
      () => {
        this.realizarDescargaPesada();
      }
    );
  };

  handleCheckboxChange = (event) => {
    this.setState({ checked: event.target.checked });
    this.setState({ buttonDisabled: !event.target.checked });
  };

  realizarDescargaPesada = () => {
    // Aqui habra que hacer la request al backend

    const urlSearchParams = new URLSearchParams();
    for (const [key, value] of Object.entries(this.state.bodyRequest)) {
      urlSearchParams.append(key, typeof value === 'object' ? JSON.stringify(value) : value);
    }
    const formData = urlSearchParams.toString();

    fetch(this.props.exportURL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: formData
    })
      .then((response) => {
        if (!response.ok) {
          toast.error(getTranslatedKey('modalToastErrorDescarrega'));
        } else {
          // toast.info('Petició enviada correctament');
          return response.json();
        }
        // this.props.handleLoading(false);
      })
      .then((data) => {
        if (data && data.midaInadequada) {
          toast.error(getTranslatedKey('modalToastErrorMida'), {
            autoClose: 7000,
            pauseOnHover: true
          });
          toast.info(getTranslatedKey('modalToastInfoSeleccionar'), {
            autoClose: 7000,
            pauseOnHover: true
          });
        } else {
          toast.info(getTranslatedKey('modalToastInfoEnviat'));
        }
      })
      .catch((error) => {
        console.error('Error', error);
        toast.error(getTranslatedKey('modalToastErrorPeticio'));
      });

    this.props.toggleAlert(false);
  };

  render() {
    return (
      <>
        <CorreoContainer>
          <FormCorreo onSubmit={this.handleSubmit}>
            <TextCorreo>
              <p>{this.props.userEmail ? getTranslatedKey('modalLoggedUserEmail') : getTranslatedKey('modalNotLoggedUserEmail')}</p>
              <br />
              <Correo>
                <IconoCorreo />
                <InputCorreo
                  type="email"
                  id="correo"
                  nombre="correo"
                  onFocus={this.handleFocus}
                  onChange={this.handleEmailChange}
                  value={this.state.email}
                  placeholder={this.state.isFocused ? '' : getTranslatedKey('modalInputPlaceholderEmail')}
                  required
                />
              </Correo>
              {/* <br /> */}
              <IconoAlerta />
              <TextCorreoAlerta>
                <p>{getTranslatedKey('modalTextExportData1')}</p>
                <p>
                  <b>{getTranslatedKey('modalTextExportData2')}</b>
                  <br />
                  <b>{getTranslatedKey('modalTextExportData3')}</b> {getTranslatedKey('modalTextExportData4')}
                  <br />
                  <b>{getTranslatedKey('modalTextExportData5')}</b> {getTranslatedKey('modalTextExportData6')}
                  <br />
                  <b>{getTranslatedKey('modalTextExportData7')}</b> {getTranslatedKey('modalTextExportData8')}
                  <br />
                  <b>{getTranslatedKey('modalTextExportData9')}</b> {getTranslatedKey('modalTextExportData10') + ' '}
                  <TextCorreoLink href="https://territori.gencat.cat/tractament_dades_drets">
                    {getTranslatedKey('modalTextExportData11')}
                  </TextCorreoLink>
                  <br />
                  <b>{getTranslatedKey('modalTextExportData12')}</b> {getTranslatedKey('modalTextExportData13') + ' '}
                  <TextCorreoLink href="https://territori.gencat.cat/tractament_dades_005">
                    {getTranslatedKey('modalTextExportData11')}
                  </TextCorreoLink>
                </p>
              </TextCorreoAlerta>
            </TextCorreo>

            <ConsentimentDades>
              <CheckboxConsentiment checked={this.state.checked} onChange={this.handleCheckboxChange} img={Data.checkboxIcon} />
              <p>{getTranslatedKey('modalTextExportData14')}</p>
            </ConsentimentDades>

            <ButtonCorreo type="submit" disabled={this.state.buttonDisabled}>
              {' '}
              {getTranslatedKey('modalTextExportData15')}{' '}
            </ButtonCorreo>
          </FormCorreo>
        </CorreoContainer>
      </>
    );
  }
}
